import { CLIENT_UID_STORAGE_KEY } from "./constants";

/**
 * Generate a unique client UID
 * @returns {string} A unique identifier string
 */
function generateClientUid() {
  // Generate a random UUID-like string
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Get or create the client UID from localStorage
 * @returns {string} The client UID
 */
export function getClientUid() {
  let clientUid = localStorage.getItem(CLIENT_UID_STORAGE_KEY);

  if (!clientUid) {
    clientUid = generateClientUid();
    localStorage.setItem(CLIENT_UID_STORAGE_KEY, clientUid);
  }

  return clientUid;
}
